{
  "auth": {
    "agree": "동의",
    "createAccount": "계정 생성",
    "createNewAccount": "새 계정 만들기",
    "email": "이메일",
    "login": "로그인",
    "password": "비밀번호",
    "recover_password": "비밀번호 찾기",
    "sign_up": "가입하기",
    "keep_logged_in": "로그인 상태 유지",
    "termsOfUse": "이용 약관",
    "reset_password": "비밀번호 변경"
  },
  "auth_group": {
    "all": "전체",
    "general_user": "일반 유저",
    "manager": "매니저",
    "admin": "관리자",
    "designer": "디자이너"
  },
  "404": {
    "title": "존재하지 않은 페이지 입니다.",
    "construction": "현재 공사 중입니다.",
    "working": "작업 중입니다. 곧 만나요",
    "back_button": "대시보드로 돌아가기"
  },
  "typography": {
    "primary": "기본 텍스트 스타일",
    "secondary": "보조 텍스트 스타일"
  },
  "dashboard": {
    "versions": "버전",
    "setupRemoteConnections": "원격 연결 설정",
    "currentVisitors": "현재 방문자",
    "navigationLayout": "내비게이션 레이아웃",
    "topBarButton": "상단 바",
    "sideBarButton": "사이드 바"
  },
  "language": {
    "english": "영어",
    "korean": "한국어"
  },
  "menu": {
    "home": "HOME",
    "auth": "권한",
    "buttons": "버튼",
    "timelines": "타임라인",
    "dashboard": "대시보드",
    "orders": "판매관리",
    "login": "로그인",
    "preferences": "계정 환경설정",
    "payments": "결제관리",
    "settings": "설정",
    "pricing-plans": "요금제",
    "payment-methods": "결제 수단",
    "404": "404",
    "faq": "자주 묻는 질문",
    "notice": "공지사항",
    "users": "회원관리",
    "stores": "스토어관리",
    "jrs": "전단지 관리",
    "jrs-edit": "전단지 편집",
    "jrs-list": "전단지 리스트",
    "jrs-assessment": "전단지 평가",
    "jrs-verification": "전단지 검증",
    "scraping": "스크래핑",
    "promotions": "이벤트관리",
    "ads": "홍보관리",
    "jrs-ads": "전단지 홍보",
    "alarm-ads": "알람 홍보",
    "search-suggestion-ads": "검색 홍보",
    "search-sns-ads": "SNS 홍보"
  },
  "messages": {
    "all": "모든 메시지 보기",
    "new": "{name}님으로부터의 새 메시지",
    "mark_as_read": "읽음으로 표시"
  },
  "navbar": {
    "messageUs": "웹 개발 문의:",
    "repository": "GitHub 리포지토리"
  },
  "notifications": {
    "all": "모든 알림 보기",
    "less": "알림 줄여 보기",
    "mark_as_read": "읽음으로 표시",
    "sentMessage": "메시지를 보냈습니다",
    "uploadedZip": "{type}이 포함된 새 Zip 파일을 업로드했습니다",
    "startedTopic": "새로운 주제를 시작했습니다"
  },
  "user": {
    "language": "언어 변경",
    "logout": "로그아웃",
    "profile": "프로필",
    "settings": "설정",
    "billing": "결제",
    "faq": "자주 묻는 질문",
    "helpAndSupport": "도움말 및 지원",
    "projects": "프로젝트",
    "account": "계정",
    "explore": "둘러보기",
    "create_user": "사용자 생성",
    "update_user": "사용자 정보 갱신"
  },
  "order": {
    "user_order_detail": "고객 주문 상세",
    "ad_order_detail": "스토어 주문 상세",
    "cancelReason": "취소 사유"
  },
  "table": {
    "number": "번호",
    "name": "이름",
    "phone": "연락처",
    "email": "이메일",
    "manager": "매니저",
    "registration_date": "등록일",
    "store_name": "매장명",
    "address": "주소",
    "registered_manager": "등록매니저",
    "number_of_manager": "총매니저수",
    "additional_managers": "매니저"
  },
  "form": {},
  "label": {
    "ad_title": "홍보",
    "authType": "권한 유형",
    "date": "날짜",
    "selection": "선택",
    "name": "이름",
    "user_id": "사용자 ID",
    "user_email": "사용자 Email",
    "phone": "연락처",
    "user_permission": "유저 권한",
    "company_name": "회사명",
    "job_title": "직함",
    "store": "매장",
    "manager": "매니저",
    "product_name": "제품명",
    "quantity": "수량",
    "price": "가격",
    "order_name": "주문명",
    "order_number": "주문번호",
    "order_amount": "주문금액",
    "order_status": "주문상태",
    "payment_company": "결제회사",
    "note": "비고",
    "customer_information": "고객 정보",
    "product_information": "상품 정보",
    "order_details": "주문 상세",
    "store_information": "스토어 정보",
    "order_information": "결제 정보",
    "sns_id": "소셜 아이디",
    "sns_type": "소셜 타입",
    "sns_token": "소셜 토큰",
    "notification_token": "알림 토큰"
  },
  "button": {
    "edit_image": "이미지 수정",
    "edit_business_license": "사업자 등록증 수정",
    "add_store": "스토어 추가",
    "edit_store": "스토어 수정",
    "close": "닫기",
    "cancel": "취소",
    "showMore": "더 보기",
    "readMore": "더 보기",
    "cancelOrder": "주문취소",
    "viewReceipt": "영수증보기"
  },
  "treeView": {
    "basic": "기본",
    "icons": "아이콘",
    "selectable": "선택 가능",
    "editable": "편집 가능",
    "advanced": "고급"
  },
  "chat": {
    "title": "채팅",
    "sendButton": "보내기"
  },
  "spacingPlayground": {
    "value": "값",
    "margin": "마진",
    "padding": "패딩"
  },
  "spacing": {
    "title": "간격"
  },
  "cards": {
    "cards": "카드",
    "fixed": "고정",
    "floating": "떠다니는",
    "contentText": "얼룩말의 독특한 줄무늬는 사람들이 가장 잘 아는 동물 중 하나입니다.",
    "contentTextLong": "얼룩말의 독특한 줄무늬는 사람들이 가장 잘 아는 동물 중 하나입니다. 이들은 초원, 사바나, 삼림지, 가시 덤불, 산, 해안 언덕 등 다양한 서식지에서 발견됩니다. 가죽 사냥과 서식지 파괴와 같은 여러 인위적 요인들이 얼룩말 개체 수에 심각한 영향을 미쳤습니다. 그레비얼룩말과 산얼룩말은 멸종 위기에 처해 있습니다. 평원얼룩말은 훨씬 더 풍부하지만, 아종 중 하나인 콰가는...",
    "rowHeight": "행 높이",
    "title": {
      "default": "기본",
      "withControls": "컨트롤 포함",
      "customHeader": "사용자 정의 헤더",
      "withoutHeader": "헤더 없음",
      "withImage": "이미지 포함",
      "withTitleOnImage": "이미지 위에 제목",
      "withCustomTitleOnImage": "이미지 위에 사용자 정의 제목",
      "withStripe": "줄무늬 포함",
      "withBackground": "배경 포함"
    },
    "link": {
      "edit": "편집",
      "setAsDefault": "기본값으로 설정",
      "delete": "삭제",
      "traveling": "여행",
      "france": "프랑스",
      "review": "리뷰",
      "feedback": "피드백 남기기",
      "readFull": "전체 기사 읽기",
      "secondaryAction": "보조 작업",
      "action1": "작업 1",
      "action2": "작업 2"
    }
  },
  "colors": {
    "themeColors": "테마 색상",
    "extraColors": "추가 색상",
    "gradients": {
      "basic": {
        "title": "기본 버튼 그라데이션"
      },
      "hovered": {
        "title": "마우스 오버 시 버튼 그라데이션",
        "text": "원래 스타일(그라데이션 또는 단색)에 15% 밝게 적용하여 마우스 오버 상태를 만듭니다."
      },
      "pressed": {
        "title": "클릭 시 버튼 그라데이션",
        "text": "원래 스타일(그라데이션 또는 단색)에 15% 어둡게 적용하여 클릭 상태를 만듭니다."
      }
    }
  },
  "tabs": {
    "alignment": "탭 정렬",
    "overflow": "탭 오버플로",
    "hidden": "슬라이더 숨김 탭",
    "grow": "탭 확장"
  },
  "helpAndSupport": "도움말 및 지원",
  "aboutVuesticAdmin": "Vuestic Admin 소개",
  "search": {
    "search": "검색",
    "placeholder": "검색..."
  },
  "buttonSelect": {
    "dark": "다크 모드",
    "light": "라이트 모드"
  },
  "settings": {
    "settings": "설정",
    "theme": "테마",
    "general_preferences": "일반 설정"
  },
  "validators": {
    "require": "필수 항목입니다.",
    "isNumber": "숫자만 입력 가능합니다.",
    "save_change": "변경 사항 저장"
  },
  "vuestic": {
    "select": "선택",
    "breadcrumbs": "네비",
    "toggleDropdown": "드롭다운 전환",
    "pagination": "페이지",
    "goToTheFirstPage": "첫페이지",
    "goToPreviousPage": "이전페이지",
    "goToSpecificPage": "그페이지",
    "goNextPage": "다음페이지",
    "goLastPage": "마지막페이지",
    "close": "닫기"
  }
}
